import countries from './country.js';
import currencyCodes from './currency-codes-convert';
export default {
  methods: {
    getCountries() {
      return Object.keys(countries.country).map(function (key) {
        return {
          value:key,
          text:countries.country[key],
        };
      });
    },
    formatPrice(value) {
      let val = value
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    convertPriceAdyen(currency,value){
      const index = currencyCodes.findIndex((curr)=>{
        return curr.code===currency;
      });
      const currCodes = currencyCodes[index];
      if(currCodes.decimals!==0){
        return value*(Math.pow(10,currCodes.decimals));
      }
      return value
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/helpers.mixins.js